
import { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { Poll } from '@/types/poll';

export const usePollDelete = (
  polls: Poll[], 
  setPolls: React.Dispatch<React.SetStateAction<Poll[]>>
) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeletePoll = async (id: string) => {
    try {
      setIsDeleting(true);
      const { error } = await supabase
        .from('polls')
        .delete()
        .eq('id', id);
      
      if (error) {
        toast.error('Failed to delete poll');
        return;
      }
      
      setPolls(polls.filter(poll => poll.id !== id));
      toast.success('Poll deleted');
    } catch (error) {
      console.error('Error deleting poll:', error);
      toast.error('An error occurred while deleting the poll');
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    handleDeletePoll,
    isDeleting
  };
};
